<div class="text-box-container">
  <div class="question-header">
    <h6 class="m-0 p-0"
    [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
    [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
    [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
    [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if(question?.required) {
      <span 
      [style.font-size]="'18px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
      >*</span>
      }
    </h6>
  </div>

  <div class="question-content-nps">
    @switch(representation) { @case(npsRepresentation.BOXES) { @switch(colorScheme) {
    @case(npsColor.GRADIENT) {
    <div class="nps-container nps-container-boxes-gradient">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-boxes">
        @for(score of npsScale; track score) {
        <div
          class="nps-box-gradient"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } @case(npsColor.TRICOLOR) {
    <div class="nps-container nps-container-boxes-tricolor">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-boxes">
        @for(score of npsScale; track score) {
        <div
          class="nps-box-tricolor"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } @default {
    <div class="nps-container nps-container-boxes-default">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-boxes">
        @for(score of npsScale; track score) {
        <div
          class="nps-box-default"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } } } @case(npsRepresentation.CIRCLES) { @switch(colorScheme) { @case(npsColor.GRADIENT) {
    <div class="nps-container nps-container-circles-gradient">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-circles">
        @for(score of npsScale; track score) {
        <div
          class="nps-circle-gradient"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } @case(npsColor.TRICOLOR) {
    <div class="nps-container nps-container-circles-tricolor">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-circles">
        @for(score of npsScale; track score) {
        <div
          class="nps-circle-tricolor"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } @default {
    <div class="nps-container nps-container-circles-default">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-circles">
        @for(score of npsScale; track score) {
        <div
          class="nps-circle-default"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } } } @case(npsRepresentation.RECTANGLES) { @switch(colorScheme) { @case(npsColor.GRADIENT) {
    <div class="nps-container nps-container-rectangles-gradient">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-rectangles">
        @for(score of npsScale; track score) {
        <div
          class="nps-rectangle-gradient"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } @case(npsColor.TRICOLOR) {
    <div class="nps-container nps-container-rectangles-tricolor">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-rectangles">
        @for(score of npsScale; track score) {
        <div
          class="nps-rectangle-tricolor"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } @default {
    <div class="nps-container nps-container-rectangles-default">
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div class="nps-labels" [ngClass]="'labels-row-width-' + getScaleArray(toNumber(11)).length">
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
          <span class="nps-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }
      <div class="nps-scale nps-scale-rectangles">
        @for(score of npsScale; track score) {
        <div
          class="nps-rectangle-default"
          [class]="getScoreClass(score)"
          [class.selected]="selectedScore === score"
          [class.highlighted]="isScoreHighlighted(score)"
          (click)="onScoreSelect(score)"
        >
          <span class="score-number">{{ score }}</span>
        </div>
        }
      </div>
    </div>
    } } } }
  </div>

  <!-- Follow-up Question Section -->
  @if(currentFollowUpQuestions && currentFollowUpQuestions.length > 0 && selectedScore !== null) {
  @for (followUpQuestion of currentFollowUpQuestions; track followUpQuestion.followUpQuestionId ||
  followUpQuestion.questionId || $index; let i = $index) { 
  @let questionId = followUpQuestion.followUpQuestionId || followUpQuestion.questionId; 
  @let questionText = followUpQuestion.followUpQuestion || followUpQuestion.question;
  <div class="follow-up-question-container mt-4 p-4 border rounded">
    <h6 class="mb-3 fw-semibold">
      <span class="follow-up-question-number">F{{ i + 1 }}.</span>
      <span class="follow-up-question-text">{{ questionText | titlecase }}</span>
    </h6>
    
    @if(followUpQuestion.followUpQuestionType === questionType.CHOICE_BASED || 
        followUpQuestion.questionType === questionType.CHOICE_BASED ||
        followUpQuestion.questionType === 'CHOICE_BASED') {
      @if((followUpQuestion.followUpQuestionOptions && followUpQuestion.followUpQuestionOptions.length > 0) || 
          (followUpQuestion.questionOptions && followUpQuestion.questionOptions.length > 0)) {
        <div class="follow-up-options">
          @for (option of getFollowUpQuestionOptions(followUpQuestion); track option.optionId ||
          option.text || $index) {
            <div class="form-check mb-2">
              <input
                class="form-check-input"
                type="checkbox"
                [name]="'followUp_' + questionId + '_' + $index"
                (click)="$event.stopPropagation()"
                [id]="'option_' + questionId + '_' + (option.optionId || $index) + '_' + $index"
                [checked]="isOptionSelected(questionId, option.optionId || option.text)"
                (change)="
                  onFollowUpOptionSelect(questionId, option.optionId || option.text, true);
                  $event.stopPropagation()
                "
              />
              <label class="form-check-label" [for]="'option_' + questionId + '_' + (option.optionId || $index) + '_' + $index">
                {{ option.text }}
              </label>
            </div>
          }
        </div>
      }
    } @else if(followUpQuestion.followUpQuestionType === questionType.TEXT_INPUT || 
               followUpQuestion.questionType === questionType.TEXT_INPUT ||
               followUpQuestion.questionType === 'TEXT_INPUT' ||
               followUpQuestion.questionType === 'TEXT') {
      <div class="follow-up-text-input">
        <app-textarea
          [rows]="3"
          [formControl]="getFollowUpResponseControl(questionId)"
          placeholder="Enter your response..."
          (click)="$event.stopPropagation()"
        ></app-textarea>
      </div>
    }
  </div>
  } }
  <!-- End of Follow-up Question Section -->
</div>
